<api-call-gate
  [apiCall]="[
    this.systemOverviewService.systemDetails,
    this.systemOverviewService.modalities,
  ]"
  [loadingLabel]="'label.loadingOverview' | translate"
  [errorBehaviors]="errorBehaviors"
>
  <ng-template #lastSuccessfulData>
    <app-system-overview-switch></app-system-overview-switch>
  </ng-template>
</api-call-gate>
